// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import { AddTradePartnerModal_BidPackageFragmentDoc } from '../../components/AddTradePartnerModal.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables = Types.Exact<{
  bidPackageId: Types.Scalars['ID']['input'];
  productOfferingId: Types.Scalars['ID']['input'];
}>;


export type PlanBasedBidsTableV2_BidPlanChildGroupsQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, bidPlanGroups: Array<{ __typename?: 'BidPlanGroup', id: string, order: number, globalOption?: { __typename?: 'GlobalOption', id: string, name: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, globalOptionType: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string }> }>, childGroups: Array<{ __typename?: 'BidPlanChildGroup', id: string, displayName: string, lines: Array<{ __typename?: 'BidPlanChildGroupLine', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> }> }> }> } };

export type PlanBasedBidsTableV2_BidPackageFragment = { __typename?: 'BidPackage', id: string, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus }, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, activeRequests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined } }> }, requests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string } }> };

export type PlanBasedBidsTableV2_BidPackageRequestFragment = { __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export type PlanBasedBidsTableV2_BidContractRevisionFragment = { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined } };

export type PlanBasedBidsTableV2_BidPlanGroupFragment = { __typename?: 'BidPlanGroup', id: string, order: number, globalOption?: { __typename?: 'GlobalOption', id: string, name: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, globalOptionType: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string }> }>, childGroups: Array<{ __typename?: 'BidPlanChildGroup', id: string, displayName: string, lines: Array<{ __typename?: 'BidPlanChildGroupLine', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> }> }> };

export type PlanBasedBidsTableV2_BidPlanGroupDimensionFragment = { __typename?: 'BidPlanGroupDimension', id: string, globalOptionType: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string }> };

export type PlanBasedBidsTableV2_BidPlanChildGroupLineFragment = { __typename?: 'BidPlanChildGroupLine', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> };

export type PlanBasedBidsTableV2_BidPlanChildGroupFragment = { __typename?: 'BidPlanChildGroup', id: string, displayName: string, lines: Array<{ __typename?: 'BidPlanChildGroupLine', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> }> };

export const PlanBasedBidsTableV2_BidPackageRequestFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPackageRequest on BidPackageRequest {
  id
  tradePartner {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const PlanBasedBidsTableV2_BidContractRevisionFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidContractRevision on BidContractRevision {
  id
  bidContract {
    id
    tradePartner {
      id
    }
  }
}
    `;
export const PlanBasedBidsTableV2_BidPackageFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPackage on BidPackage {
  id
  status {
    code
  }
  productOfferings {
    ...Named
  }
  costCodes {
    ...Named
  }
  activeRequests {
    ...PlanBasedBidsTableV2_BidPackageRequest
  }
  latestVersion {
    id
    latestBidContractRevisions {
      ...PlanBasedBidsTableV2_BidContractRevision
    }
  }
  ...AddTradePartnerModal_BidPackage
}
    ${NamedFragmentDoc}
${PlanBasedBidsTableV2_BidPackageRequestFragmentDoc}
${PlanBasedBidsTableV2_BidContractRevisionFragmentDoc}
${AddTradePartnerModal_BidPackageFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanGroupDimensionFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPlanGroupDimension on BidPlanGroupDimension {
  id
  globalOptionType {
    ...Named
  }
  globalOptions {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanChildGroupLineFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPlanChildGroupLine on BidPlanChildGroupLine {
  id
  options {
    id
    globalOption {
      ...Named
      type {
        id
      }
    }
  }
  planBasedBidContractLineItems {
    id
    totalCostInCents
    costCode {
      id
    }
    revision {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanChildGroupFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPlanChildGroup on BidPlanChildGroup {
  id
  displayName
  lines {
    ...PlanBasedBidsTableV2_BidPlanChildGroupLine
  }
}
    ${PlanBasedBidsTableV2_BidPlanChildGroupLineFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanGroupFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPlanGroup on BidPlanGroup {
  id
  order
  globalOption {
    ...Named
  }
  dimensions {
    ...PlanBasedBidsTableV2_BidPlanGroupDimension
  }
  childGroups(productOfferingId: $productOfferingId) {
    ...PlanBasedBidsTableV2_BidPlanChildGroup
  }
}
    ${NamedFragmentDoc}
${PlanBasedBidsTableV2_BidPlanGroupDimensionFragmentDoc}
${PlanBasedBidsTableV2_BidPlanChildGroupFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanChildGroupsDocument = gql`
    query PlanBasedBidsTableV2_BidPlanChildGroups($bidPackageId: ID!, $productOfferingId: ID!) {
  bidPackage(id: $bidPackageId) {
    id
    bidPlanGroups {
      ...PlanBasedBidsTableV2_BidPlanGroup
    }
  }
}
    ${PlanBasedBidsTableV2_BidPlanGroupFragmentDoc}`;

/**
 * __usePlanBasedBidsTableV2_BidPlanChildGroupsQuery__
 *
 * To run a query within a React component, call `usePlanBasedBidsTableV2_BidPlanChildGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBasedBidsTableV2_BidPlanChildGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBasedBidsTableV2_BidPlanChildGroupsQuery({
 *   variables: {
 *      bidPackageId: // value for 'bidPackageId'
 *      productOfferingId: // value for 'productOfferingId'
 *   },
 * });
 */
export function usePlanBasedBidsTableV2_BidPlanChildGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables> & ({ variables: PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>(PlanBasedBidsTableV2_BidPlanChildGroupsDocument, options);
      }
export function usePlanBasedBidsTableV2_BidPlanChildGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>(PlanBasedBidsTableV2_BidPlanChildGroupsDocument, options);
        }
// @ts-ignore
export function usePlanBasedBidsTableV2_BidPlanChildGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>;
export function usePlanBasedBidsTableV2_BidPlanChildGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidsTableV2_BidPlanChildGroupsQuery | undefined, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>;
export function usePlanBasedBidsTableV2_BidPlanChildGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>(PlanBasedBidsTableV2_BidPlanChildGroupsDocument, options);
        }
export type PlanBasedBidsTableV2_BidPlanChildGroupsQueryHookResult = ReturnType<typeof usePlanBasedBidsTableV2_BidPlanChildGroupsQuery>;
export type PlanBasedBidsTableV2_BidPlanChildGroupsLazyQueryHookResult = ReturnType<typeof usePlanBasedBidsTableV2_BidPlanChildGroupsLazyQuery>;
export type PlanBasedBidsTableV2_BidPlanChildGroupsSuspenseQueryHookResult = ReturnType<typeof usePlanBasedBidsTableV2_BidPlanChildGroupsSuspenseQuery>;
export type PlanBasedBidsTableV2_BidPlanChildGroupsQueryResult = Apollo.QueryResult<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>;